import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
export function logUnreachableAction(store, loggers, action) {
    loggers.traceLogger.logTrace(0x1e1c25e3 /* tag_4hcx9 */ , TraceLevel.Warning, `Unexpected action encountered: [ActionType=${action.type}][Store=${store.name}]`);
}
